module.exports = __webpack_public_path__ + "static/media/cloud-sun-rain.fb2a6c3a.svg";